<template>
  <div class="h-100">
    <div v-if="!unitsLoaded" :class="`omniview-map omniview-map-${mapId}`"></div>
    <div
      v-else
      style="display: flex; align-items: center; justify-content: center"
    >
      <b-spinner label="Spinning" variant="primary"></b-spinner>
    </div>
  </div>
</template>

<script>
import { BSpinner } from "bootstrap-vue";
import { Map as OMS } from "@omnicloud/maps-sdk";
import store from "@/store";
import { SLOT_TYPES } from "@/config/layoutConfig";
import { v4 as uuidv4 } from "uuid";
import useAppConfig from "@core/app-config/useAppConfig";
import { EventBus } from "@/libs/event-bus";
import { watch } from '@vue/composition-api';
import { getCspNonce } from "@/utils/cspNonce";

const token = window.localStorage.accessToken;

export default {
  components: {
    BSpinner,
  },
  data() {
    return {
      mapSelector: null,
      SLOT_TYPES,
      mapId: uuidv4(),
      unitsLoaded: false,
      map: null,
      currentZoom: null,
      lastMarkerClicked: null,
      originalUnits: null,
    };
  },
  props: {
    filters: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    units() {
      return store.state.grid.units;
    },
    loadingUnitsStatus() {
      return store.state.grid.loadingUnits;
    },
  },
  async mounted() {
    if (!this.loadingUnitsStatus && !this.units.length) {
      // TODO: Check if this is necesary
      await store.dispatch("grid/getUnitsByTenant");
      this.unitsLoaded = true;
    } else if (this.units.length > 0) {
      this.$nextTick(() => this.initMap());
      this.unitsLoaded = true;
    }

    if (this.units.length > 0 && !this.originalUnits) {
      this.originalUnits = [...this.units];
    }
    EventBus.on("update-components", this.refreshMap);
    EventBus.on("apply-filters", this.applyFilters);
    EventBus.on("get-geojson", this.exportGeoJson);
  },
  beforeDestroy() {
    if (this.mapSelector) {
      this.mapSelector.removeEventListener(
        "booklet:click",
        this.onClickBooklet
      );
      this.mapSelector.removeEventListener(
        "status:click",
        this.onClickChangeStatus
      );
    }

    EventBus.off("update-components", this.refreshMap);
  },
  watch: {
    units(value) {
        //console.log("watch units")
        this.unitsLoaded = true;
        this.$nextTick(() => this.initMap());
    },
    '$i18n.locale'(locale) {
      this.map?.setLocale(locale);
    },
  },
  methods: {
    initMap() {
      //console.log("init Map");
      let today = new Date();
      today.setHours(0, 0, 0, 0); // Establecer a medianoche para comparar solo fechas y no tiempos exactos

      let filteredUnits = this.units.filter((unit) => {
        if (
          unit.service_order &&
          Array.isArray(unit.service_order) &&
          unit.service_order.length > 0
        ) {
          // Filtrar las service_orders por estatus
          unit.service_order = unit.service_order.filter((serviceOrder) => {
            let attentionDate = new Date(serviceOrder.attention_date);
            attentionDate.setHours(0, 0, 0, 0);

            // Se conservan las service_order si NO son 'finished' o son 'finished' pero del día actual
            return !(
              serviceOrder.latest_status.status === "finished" &&
              attentionDate.getTime() !== today.getTime()
            );
          });

          // Conservar la unit solo si todavía tiene service_orders después del filtrado
          return unit.service_order.length > 0;
        }

        return false; // Excluir esta unit si no tiene service_orders relevantes
      });

      //console.log("filtered", filteredUnits);

      if (this.map) {
        //console.log("changeMarkers");
        this.map.changeMarkers(filteredUnits);
        setTimeout(() => {
          // this.setMapCenter(filteredUnits);
          // if (this.currentZoom) {
          //   this.map.setZoom(this.currentZoom);
          // } else {
          //   this.map.setZoom(5); //esto es para que haga el zoom y quite las anteriores, no lo tengamos que hacer manual.
          // }

          // if (this.lastMarkerClicked)
          //   this.map.setMarkerClick(this.lastMarkerClicked);
        }, 1000);
        return;
      }

      try {
        this.map = new OMS({
          token,
          apiUrl: `${process.env.VUE_APP_BASE_URL}/v1`,
          locale: this.$i18n.locale,
        });

        const { skin } = useAppConfig();

        const selector = `.omniview-map-${this.mapId}`;
        const drawingData =
          this.data && this.data.drawingData ? this.data.drawingData : null;
        this.mapSelector = document.querySelector(selector);

        //console.log(this.mapSelector)

        let latlng = this.data?.center || { lat: 19.39068, lng: -99.2836975 };

        this.map.setConfig({
          container: selector,
          latLng: latlng,
          gmapsKey: process.env.VUE_APP_GMAPS_KEY,
          triggerEvents: true,
          mode: "units",
          drawingData,
          locale: this.$i18n.locale,
          zoom: this.data?.zoom || 5,
          darkMode: skin.value == "dark" ? true : false,
          maintenance: true,
          nonce: getCspNonce(),
        });

        //console.log(JSON.stringify(this.units));
        //console.log(this.map);

        //console.log("filteredUnits", filteredUnits);

        this.map.onMapReady().then(() => {
          this.map.setMarkers(filteredUnits);
          setTimeout(() => {
            this.setMapCenter(filteredUnits);
            if (this.currentZoom) {
              this.map.setZoom(this.currentZoom);
            } else {
              this.map.setZoom(5); //esto es para que haga el zoom y quite las anteriores, no lo tengamos que hacer manual.
            }

            if (this.lastMarkerClicked)
              this.map.setMarkerClick(this.lastMarkerClicked);
          }, 1000);
        });

        if (this.mapSelector) {
          this.mapSelector.addEventListener(
            "booklet:click",
            this.onClickBooklet
          );
          this.mapSelector.addEventListener(
            "status:click",
            this.onClickChangeStatus
          );
          //   this.mapSelector.addEventListener("camera:click", this.onCameraClick);
          //   this.mapSelector.addEventListener(
          //     "camera:click-float",
          //     this.onCameraClickFloat
          //   );
          //   this.mapSelector.addEventListener("plane:click", this.onClickPlane);
          //   this.mapSelector.addEventListener(
          //     "circle:updated",
          //     this.onCircleUpdated
          //   );
          //   this.mapSelector.addEventListener(
          //     "circle:removed",
          //     this.onCircleRemoved
          //   );
          //   this.mapSelector.addEventListener("map:idle", this.onIdle);
        }
      } catch (error) {
        console.error("Map|SetConfig", error);
      }
    },
    setMapCenter(units) {
      const unit = units.find((u) => u.id == this.unit_id);
      if (unit) {
        this.map.setCenter(
          parseFloat(unit.coordinates.lat),
          parseFloat(unit.coordinates.lng),
          20
        );
      }
    },
    applyFilters() {
      //console.log("apply filters map");
      //console.log(this.filters);
      //console.log(this.originalUnits);
      const filteredUnits = this.originalUnits.filter((unit) => {
        // console.log(unit.service_order);
        // Filtro por ID de unidad
        const unitFilterMatch =
          this.filters.unitFilter.length === 0 ||
          this.filters.unitFilter.includes(unit.id);

        // Filtro por estado
        const statusFilterMatch = unit.service_order.some((serviceOrder) => {
          return (
            this.filters.statusFilter == null ||
            this.filters.statusFilter == serviceOrder.latest_status.id
          );
        });

        // Filtro por fechas
        let dateFilterMatch = true;
        if (this.filters.startDate && this.filters.endDate) {
          const startDate = new Date(this.filters.startDate);
          const endDate = new Date(this.filters.endDate);
          dateFilterMatch = unit.service_order.some((serviceOrder) => {
            const attentionDate = new Date(serviceOrder.attention_date);
            return attentionDate >= startDate && attentionDate <= endDate;
          });
        }

        // console.log(unitFilterMatch);
        // console.log(statusFilterMatch);
        // console.log(dateFilterMatch);
        // Combinar todos los filtros
        return unitFilterMatch && statusFilterMatch && dateFilterMatch;
      });

      if (this.map) {
        //console.log(filteredUnits);
        store.dispatch("grid/setUnits", filteredUnits);
        // this.map.setMarkers(filteredUnits);
        // this.map.toggleMaintenanceOn();
      }
    },
    async refreshMap() {
      //console.log("refreshMap");
      this.currentZoom = this.map.getCurrentZoom();
      this.lastMarkerClicked = this.map.getLastMarkerClicked();

      await store.dispatch("grid/getUnitsByTenant");
      if (this.units.length > 0 ) {
        this.originalUnits = [...this.units];
      }
      //console.log("end refreshMap");
    },
    onClickBooklet({ detail }) {
      this.$emit("showBookletModal", detail);
    },
    onClickChangeStatus({ detail }) {
      this.$emit("showStatusModal", detail);
    },
    exportGeoJson() {
      let geojson = this.map.getMarkersGeoJSON();
      //console.log(geojson);
      // Convertir el objeto GeoJSON a cadena
      const geojsonStr = JSON.stringify(geojson);

      // Crear un Blob con el contenido de GeoJSON
      const blob = new Blob([geojsonStr], { type: "application/geo+json" });

      // Crear un enlace y descargar el archivo
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = "markers.geojson";
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
  },
};
</script>

<style lang="scss" scoped>
.omniview-map {
  width: 100%;
  height: 100%;
  position: fixed !important;
}
</style>
